/** Resultado de insertar texto en un textarea controlado: valor final y posición de cursor. */
export interface InsertAtCursorResult {
  next: string;
  cursor: number;
}

/**
 * Inserta `insertText` en la posición del cursor (o reemplaza la selección) de un textarea
 * controlado por React. Sin `textarea` o sin selección activa, hace `append` al final. Si el
 * resultado excede `maxLength`, la inserción se rechaza por completo y se devuelve el texto
 * original sin cambios (mismo comportamiento que el atributo `maxLength` nativo de un textarea:
 * la pulsación se ignora, nada queda truncado). Truncar a `maxLength` con `String.slice` podía
 * cortar un par subrogado UTF-16 (p. ej. un emoji) y dejar un carácter mal formado (U+FFFD).
 */
export function insertAtCursor(
  textarea: HTMLTextAreaElement | null,
  current: string,
  insertText: string,
  maxLength?: number,
): InsertAtCursorResult {
  const hasSelection = textarea != null
    && typeof textarea.selectionStart === 'number'
    && typeof textarea.selectionEnd === 'number';
  const start = hasSelection ? (textarea as HTMLTextAreaElement).selectionStart : current.length;
  const end = hasSelection ? (textarea as HTMLTextAreaElement).selectionEnd : current.length;

  const next = current.slice(0, start) + insertText + current.slice(end);

  if (typeof maxLength === 'number' && next.length > maxLength) {
    return { next: current, cursor: end };
  }

  return { next, cursor: start + insertText.length };
}
